export default "__VITE_ASSET__135194cf__"